import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzUploadChangeParam, NzUploadModule, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { mergeMap, take } from 'rxjs';
import { ResumeService } from '../../../core/resume/resume.service';

@Component({
  selector: 'app-upload-resume',
  standalone: true,
  imports: [CommonModule, FormsModule, NzIconModule, NzInputModule, NzButtonModule, NzUploadModule, NzModalModule],
  templateUrl: './upload-resume.component.html',
  styleUrl: './upload-resume.component.scss',
})
export class UploadResumeComponent {
  @Input() isNewResumeVisible = false;
  @Output() isNewResumeVisibleChange = new EventEmitter<boolean>();

  constructor(
    private resumeService: ResumeService,
    private msg: NzMessageService
  ) {}

  uploadFileHandler = (item: NzUploadXHRArgs) => {
    const fileName = (item.postFile as File).name;

    return this.resumeService
      .addResume$(fileName, {})
      .pipe(
        mergeMap((newResume) => {
          return this.resumeService.uploadResume$(newResume.id, fileName, item.postFile as File);
        })
      )
      .pipe(take(1))
      .subscribe(() => {
        this.isNewResumeVisible = false;
        this.isNewResumeVisibleChange.emit(this.isNewResumeVisible);
        return true;
      });
  };

  handleChange({ file, fileList }: NzUploadChangeParam): void {
    const status = file.status;
    if (status !== 'uploading') {
      console.log(file, fileList);
    }
    if (status === 'done') {
      this.msg.success(`${file.name} file uploaded successfully.`);
    } else if (status === 'error') {
      this.msg.error(`${file.name} file upload failed.`);
    }
  }

  onCancelResumeClick() {
    this.isNewResumeVisible = false;

    this.isNewResumeVisibleChange.emit(this.isNewResumeVisible);
  }
}
